module.exports = __webpack_public_path__ + "static/media/buy0.743e0281.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/buy/buy0.png
// module id = 1293
// module chunks = 0